module.exports = __webpack_public_path__ + "media/application/images/ui/tick-peoples-choice-86bfd8131658f68e3ced5d04c77e67fd.svg";